import { useEffect, useRef, useState } from "react";
import { useLanguage } from "../i18n/LanguageContext";
import { animateCrocheting } from "./crochetMotion";
import "./css/crochetLady.css";
export default function CrochetLady() {
  const {
    t,
    language
  } = useLanguage();
  const scene = useRef(null);
  const timer = useRef(null);
  const [paused, setPaused] = useState(false);
  const [interrupted, setInterrupted] = useState(false);
  useEffect(() => animateCrocheting(scene.current.querySelector(".lady"), paused), [paused]);
  useEffect(() => () => clearTimeout(timer.current), []);
  function interrupt() {
    setInterrupted(true);
    clearTimeout(timer.current);
    timer.current = setTimeout(() => setInterrupted(false), 2200);
  }
  return <>
      <div ref={scene} className={`crochet-scene${interrupted ? " is-interrupted" : ""}`}>
        <div className="stage" role="img" aria-label={t("notFound.illustration")}>
          <div className="halo" aria-hidden="true" />
          <div className="number" aria-hidden="true"><span>4</span><span>0</span><span>4</span></div>
        <div className="lady" aria-hidden="true"><div className="bun left"></div><div className="bun right"></div><div className="hair"></div><div className="neck"></div><div className="face"><div className="fringe"></div><div className="glasses"><div className="lens"><div className="eye"></div></div><div className="lens"><div className="eye"></div></div></div><div className="nose"></div><div className="mouth"></div><div className="cheek left"></div><div className="cheek right"></div></div><div className="shirt"><div className="panda"><span className="patch left"></span><span className="patch right"></span><span className="snout"></span></div></div><div className="leg"></div><div className="leg right"></div><div className="project blanket"><span className="blanket-edge"></span></div>
          <div className="rig" aria-hidden="true">
            <div className="limb upper left"></div><div className="limb forearm left"></div><div className="limb upper right"></div><div className="limb forearm right"></div>
            <div className="wrist support-wrist"><span className="index-finger"></span><span className="thumb"></span><span className="knuckles"></span></div>
            <div className="wrist tool-wrist"><span className="tool"><span className="metal"></span><span className="real-grip"></span><span className="real-tip"></span><span className="hook-loop"></span></span><span className="thumb"></span><span className="knuckles"></span></div>
            <div className="yarn-segment feed-yarn"></div><div className="yarn-segment finger-yarn"></div><div className="yarn-segment stitch-yarn"></div>
          </div>
        </div>
          <div className="ball" aria-hidden="true" />
          <div className="speech" lang={language} dir={language === "ar" ? "rtl" : "ltr"} aria-hidden="true">{interrupted ? t("notFound.reaction") : ""}</div>
        </div>
      </div>
      <p className="visually-hidden" role="status">{interrupted ? t("notFound.reaction") : ""}</p>
      <div className="crochet-controls">
        <button type="button" onClick={interrupt}>{t("notFound.interrupt")}</button>
        <button type="button" onClick={() => setPaused(value => !value)}>{t(paused ? "notFound.resume" : "notFound.pause")}</button>
      </div>
    </>;
}
